import { createSSRApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import i18n from "./i18n";
import uviewPlus from "@/uni_modules/uview-plus";
import "@/utils/request"; // 导入即可，无需赋值

export function createApp() {
  const app = createSSRApp(App);
  const pinia = createPinia();

  app.use(i18n);
  app.use(pinia);
  app.use(uviewPlus);
  app.config.globalProperties.$t = i18n.global.t;
  return {
    app,
    i18n,
    pinia,
  };
}
